import React from 'react';
import {
  ChartBar, PlusCircle, CarProfile, Archive, UsersThree, CarSimple,
  Wrench, Sparkle, Sunglasses, IdentificationBadge, SignOut,
} from '@phosphor-icons/react';
import { ROLE_NAV, roleLabel } from '../helpers';

// ROLE_NAV still stores the legacy emoji as the icon key; map it to the
// Phosphor icon the Acts app family uses.
const NAV_ICONS = {
  '📊': ChartBar,
  '➕': PlusCircle,
  '🚗': CarProfile,
  '📦': Archive,
  '👥': UsersThree,
  '🚘': CarSimple,
  '🔧': Wrench,
  '✨': Sparkle,
  '🪟': Sunglasses,
  '🧑‍💼': IdentificationBadge,
};

export default function Sidebar({ session, currentView, onNavigate, onLogout, isMobileOpen, onMobileClose }) {

  const items = ROLE_NAV[session.role] || ROLE_NAV.Sales;
  const initial = (session.name || 'U').charAt(0).toUpperCase();

  function handleNav(v, l) {
    onNavigate(v, l);
    // Auto-close on mobile after picking an item
    onMobileClose?.();
  }

  return (
    <>
      <aside className={`sidebar ${isMobileOpen ? 'open' : ''}`}>
        <div className="sb-header">
          <div className="sb-logo">
            <div className="sb-logo-sq"><img src="/vehicle-flow-logo-256.png" alt="VF" /></div>
            <div>
              <div className="sb-logo-name">Vehicle Flow</div>
              <div className="sb-logo-sub">Melville Motors</div>
            </div>
          </div>
        </div>

        <div className="sb-nav">
          <div className="sb-section">Navigation</div>
          {items.map((item) => {
            const NavIcon = NAV_ICONS[item.i] || ChartBar;
            const active = currentView === item.v;
            return (
              <div
                key={item.v}
                className={`sb-item ${active ? 'active' : ''}`}
                onClick={() => handleNav(item.v, item.l)}
              >
                <span className="sb-item-icon">
                  <NavIcon size={17} weight={active ? 'fill' : 'duotone'} color={active ? 'var(--accent-bright)' : 'currentColor'} />
                </span>
                <span className="sb-item-label">{item.l}</span>
              </div>
            );
          })}
        </div>

        <div className="sb-footer">
          <div className="sb-user">
            <div className="sb-avatar">{initial}</div>
            <div>
              <div className="sb-user-name">{session.name}</div>
              <div className="sb-user-role">{roleLabel(session.role)}</div>
            </div>
          </div>
          <button className="sb-logout" onClick={onLogout}>
            <SignOut size={12} weight="fill" style={{ verticalAlign: '-1px', marginRight: 5 }} />
            Sign Out
          </button>
        </div>
      </aside>

      {/* Mobile overlay (renders after the aside so the aside keeps stable index) */}
      <div
        className={`sidebar-overlay ${isMobileOpen ? 'show' : ''}`}
        onClick={onMobileClose}
        style={{ display: isMobileOpen ? 'block' : 'none' }}
      />
    </>
  );
}
